$(document).ready(function() {
    var $group = $('#vk_groups');
    if (!$group.length || $group.length < 1 ) {
        return;
    }
    var vkWidgetInit = function () {
        VK.Widgets.Group("vk_groups", {mode: 4, width: 270, height: 400, color1: "FFFFFF", color2: "000000", color3: "5181B8"}, 31300638);
    };
    vkWidgetInit();
});
